import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import Loading from '../../progress/loading';

type props = {
  onClose: () => void;
};

export default function LoadingMessage({ onClose }: props) {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);

  return (
    <P2GGrid container direction="column" textAlign="center" spacing={2} dataTestId="service-switcher-loading">
      <P2GGrid item>
        <P2GText variant="h2" dataTestId="service-switcher-loaing-title" onClick={onClose}>
          {t('SERVICE_SWITCHER_LOADING_TITLE', { defaultValue: 'Checking Service Options' })}
        </P2GText>
      </P2GGrid>
      <P2GGrid item>
        <Loading />
      </P2GGrid>
    </P2GGrid>
  );
}
